import { Box, Button, Divider, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { periverseTheme } from '@peritasai/ui-shared';
import { DiscoveryPaperCard } from './DiscoveryPaperCard';
import {
  hubStatusBodySx,
  hubStatusFooterSx,
  hubStatusHeaderSx,
  hubStatusIconWrapSx,
  hubStatusMessageSx,
  hubStatusPaperCardSx,
  hubStatusTitleSx,
} from './styles';

type HubStatusCardProps = {
  title: string;
  message: string;
  onConfirm: () => void;
};

export const HubStatusCard = ({
  title,
  message,
  onConfirm,
}: HubStatusCardProps) => (
  <DiscoveryPaperCard sx={hubStatusPaperCardSx}>
    <Box sx={hubStatusHeaderSx}>
      <Box sx={hubStatusIconWrapSx}>
        <ErrorOutlineIcon
          sx={{ color: periverseTheme.palette.warning.main, fontSize: '24px' }}
        />
      </Box>
      <Typography sx={hubStatusTitleSx}>{title}</Typography>
    </Box>
    <Divider />
    <Box sx={hubStatusBodySx}>
      <Typography sx={hubStatusMessageSx}>{message}</Typography>
      <Typography sx={hubStatusMessageSx}>
        Check the station is powered on and connected, then re-open the surgical
        case.
      </Typography>
    </Box>
    <Box sx={hubStatusFooterSx}>
      <Button variant="contained" onClick={onConfirm} sx={{ minWidth: '80px' }}>
        OK
      </Button>
    </Box>
  </DiscoveryPaperCard>
);
